import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import gallery1 from "../../../assets/training/img_1.JPG";
import gallery2 from "../../../assets/training/img_2.JPG";
import gallery3 from "../../../assets/training/img_3.JPG";
import gallery4 from "../../../assets/training/img_4.JPG";
import gallery5 from "../../../assets/training/img_5.jpg";
import gallery6 from "../../../assets/training/img_6.jpg";
import gallery7 from "../../../assets/training/img_7.jpg";
import gallery8 from "../../../assets/training/img_8.jpg";
import gallery9 from "../../../assets/training/img_9.jpg";
import gallery10 from "../../../assets/training/img_10.JPG";
import gallery11 from "../../../assets/training/img_11.jpg";
import gallery12 from "../../../assets/training/img_12.jpg";
import gallery13 from "../../../assets/training/img_13.JPG";
import gallery14 from "../../../assets/training/img_14.JPG";
import gallery15 from "../../../assets/training/img_15.JPG";
import gallery16 from "../../../assets/training/img_16.JPG";
import gallery17 from "../../../assets/training/img_17.JPG";
import gallery18 from "../../../assets/training/img_18.jpg";
import gallery19 from "../../../assets/training/img_19.JPG";
import gallery20 from "../../../assets/training/img_20.JPG";
// import gallery21 from "../../../assets/training/img_21.JPG";
// import gallery22 from "../../../assets/training/img_22.JPG";
// import gallery23 from "../../../assets/training/img_23.JPG";
// import gallery24 from "../../../assets/training/img_24.JPG";

const Gallery = () => {
  const theme = useTheme();

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photos = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
    gallery13,
    gallery14,
    gallery15,
    gallery16,
    gallery17,
    gallery18,
    gallery19,
    gallery20,
    // gallery21,
    // gallery22,
    // gallery23,
    // gallery24,
  ];

  const photosToShow = isMd ? photos : photos.slice(0, photos.length);

  return (
    <Box padding={{ xs: "30% 0%", sm: "10% 0%" }}>
      <Box
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Typography
          variant={"h3"}
          fontWeight={900}
          textAlign={"left"}
          color={"#00AEEF"}
          paddingBottom={"1%"}
        >
          <Typography
            component={"span"}
            variant={"h3"}
            color="#3E4095"
            fontWeight={900}
          >
            Our {""}
          </Typography>
          Gallery
          <Divider color={"#CACACA"} paddingTop={"4%"} width={"15%"} />
        </Typography>
      </Box>
      <Box marginTop={{ xs: "5%", sm: "2%" }}>
        {photosToShow.map((item, index) => (
          <Box
            component="img"
            height={{ xs: "27vh", sm: "200px" }}
            onClick={() => {
              setCurrentImageIndex(index);
              setIsViewerOpen(!isViewerOpen);
            }}
            sx={{
              cursor: "pointer",
              objectFit: "cover",
            }}
            src={item}
            alt={"training_img"}
            marginRight={{ xs: "0%", sm: "0.5%" }}
            marginBottom={{ xs: "1%", sm: "0.5%" }}
            width={{ xs: "100%", sm: "24%" }}
          />
        ))}

        <FsLightbox
          toggler={isViewerOpen}
          sources={photos}
          slide={currentImageIndex + 1}
        />
      </Box>
    </Box>
  );
};

export default Gallery;
